import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20background%20with%20soft%20golden%20and%20cream%20gradients%2C%20elegant%20geometric%20flow%2C%20minimalist%20professional%20atmosphere%2C%20clean%20smooth%20texture%2C%20warm%20inviting%20tone%2C%20sophisticated%20editorial%20style%2C%20no%20text&width=1600&height=500&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/40 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          准备好成为优秀的版主了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-lg mx-auto">
          从第一版主核心指南开始，系统化掌握论坛管理的全部核心能力
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/jinsheng-zhinan"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            查看晋升指南
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-md backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}